import bindActionCreators from 'react-redux/lib/utils/bindActionCreators';

import { store } from 'store';

import api from './api';
import { actions as data } from './data';
import { actions as authorization } from './authorization';
import { actions as customers } from './customers';
import labs from './labs';
import grants from './grants';
import support from './support';
import cartSlice from './cart';

const actions = {
  ...api,
  ...labs,
  ...grants,
  ...support,
  ...data,
  ...authorization,
  ...customers,
  ...cartSlice.actions,
};
const dispatch = store.dispatch;
const servises = bindActionCreators(actions, dispatch);

export const {
  // AUTHORIZATION
  useAuthorizeCustomerMutation,

  // CATEGORIES
  useGetCategoriesFlatTreeQuery,
  useGetCategoriesTreeQuery,

  // SEARCH
  useSearchProductsQuery,
  useLazySearchProductsQuery,
  useSearchMembersFromCustomerGroupsQuery,
  useLazySearchMembersFromCustomerGroupsQuery,

  // PRODUCTS
  useGetProductBySlugQuery,
  useLazyGetProductBySlugQuery,
  useGetProductReviewsQuery,
  useAddReviewForProductMutation,
  useGetProductCitationsQuery,
  useGetProductAccessoriesQuery,
  useGetProductRelatedItemsQuery,
  useGetProductAvailableSuppliersQuery,
  useGetProductQuestionsQuery,
  useAddProductQuestionMutation,
  useGetFavoriteProductsQuery,
  useGetFamilyProductsQuery,

  // CUSTOMERS
  useResetPasswordRequestMutation,
  useVerifyResetPasswordHashMutation,
  useUpdatePasswordMutation,
  useGetCustomerCartsQuery,
  useGetListOfCustomerBookmarksQuery,
  useAddProductToBookmarksMutation,
  useDeleteCustomerBookmarkMutation,
  useGetCustomerAddressesQuery,
  useLazyGetCustomerAddressesQuery,
  useAddCustomerAddressMutation,
  useDeleteCustomerAddressMutation,
  useUpdateCustomerAddressMutation,
  useGetCustomerDetailsQuery,
  useUpdateCustomerDetailsMutation,
  useGetListOfCustomerPaymentMethodsQuery,
  useAddCustomerPaymentMethodMutation,
  useDeleteCustomerPaymentMethodMutation,
  useGetListOfPurchaseOrdersQuery,
  useCreateCustomerPurchaseOrderMutation,
  useDeleteCustomerPurchaseOrderMutation,
  useCancelOrderMutation,
  useCancelOrderItemMutation,
  useTagMemberMutation,
  useUntagMemberMutation,
  useGetListOfCustomerOrdersQuery,
  useGetListOfArchivedCustomerOrdersQuery,
  useGetRecentlyViewedProductsMutation,

  // SHOPPING CART
  useGetShoppingCartDetailsQuery,
  useLazyGetShoppingCartDetailsQuery,
  useAddProductToCartMutation,
  useAcceptItemInSharedCartMutation,
  useRejectItemInSharedCartMutation,
  useUpdateProductInCartMutation,
  useRemoveProductFromCartMutation,
  useGetPreviewShoppingCartQuery,
  useGetShoppingCartSummaryQuery,
  useApplyPromoCodeMutation,
  useCancelPromoCodeMutation,

  // ORDER
  usePlaceOrderMutation,
  useGetPlacedOrderDetailsQuery,
  useGetOrderShipmentStatusesQuery,
  useGetOrderDetailsQuery,
  useGetOrderCalculatorsQuery,
  useChangeOrderPaymentMethodMutation,

  // REVIEWS
  useVoteForReviewMutation,
  useGetCommentsForReviewQuery,
  useReportReviewMutation,

  // QUOTES
  useCreateQuoteRequestMutation,
  useGenerateQuoteRequestMutation,
  useCheckoutQuoteMutation,

  // DATA
  useGetListOfCountriesQuery,

  // SUPPLIER
  useGetListOfSuppliersQuery,
  useGetSupplierSetupFormDetailsQuery,
  useUpdateSupplierSetupFormMutation,
  useDeleteSetupFormFileMutation,
  useGetListOfSupplierPartnersQuery,

  // CONTENT
  useGetBlocksQuery,
  useGetNewsQuery,
  useGetNewsCategoriesQuery,
  useGetNewsArticleQuery,

  //BLOG
  useGetBlogArticlesQuery,
  useGetBlogCategoriesQuery,
  useGetBlogArticleDetailsQuery,
  usePostJoinOurListMutation,

  //CAREER
  useGetCareersVacanciesQuery,
  useGetCareersVacancyDetailsQuery,
  useGetCareersVacancyCategoriesQuery,

  //HELP CENTER
  useGetHelpCenterCategoriesQuery,
  useGetHelpCenterArticleDetailsQuery,
  useGetHelpCenterArticlesQuery,
  useUpdateHelpCenterHelpfulMutation,

  // PUNCHOUT
  usePunchoutAuthenticationMutation,

  // STRAPI
  useGetCareerArticleDetailsQuery,
  usePutBlogArticleViewCounterMutation,

  // Documents
  useGetDocumentsQuery,
  useGetDocumentMutation,
  usePostDocumentMutation,
  useDeleteDocumentMutation,
} = api;

export const {
  useGetListCustomerGroupsQuery,
  useCreateCustomerGroupMutation,
  usePatchCustomerGroupMutation,
  useDeleteCustomerGroupMutation,
  useMergeCustomerGroupsMutation,
  useGetGroupMembersQuery,
  useCreateCustomerGroupInviteMutation,
  useAcceptCustomerGroupInvitationMutation,
  useCancelCustomerGroupInvitationMutation,
  useRejectCustomerGroupInviteMutation,
  useDeleteCustomerGroupMemberMutation,
  useGetCustomerGroupSettingsQuery,
  usePatchCustomerGroupSettingsMutation,
  useLazyGetGroupMembersQuery,
} = labs;

export const {
  useGetGrantsQuery,
  useCreateGrantMutation,
  useUpdateGrantMutation,
  useDeleteGrantMutation,
} = grants;

export const {
  useGetTicketsQuery,
  useSetTicketMutation,
  useSendSupportTicketReplyMutation,
  useResolveSupportTicketReplyMutation,
  useReportBugMutation,
  usePostSuggestionMutation,
  usePostCurationMutation,
  usePostPreferredPricesMutation,
  usePostDemoMutation,
  usePostSupplierMutation,
  usePostInvoiceMutation,
  usePostCheckOrderStatusMutation,
  usePostConfirmAvailabilityMutation,
  usePostProductDocumentsMutation,
  usePostSupportTicketMutation,
  useApplyCareerJobMutation,
  useGetRequestQuotesQuery,
  useDeleteRequestQuoteMutation,
} = support;

export default servises;
